
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3.594l.719.688 5.938 5.969 1 .969-1.281.625s-1.015.366-2.438.688l4.406 4.406 1 .969-1.25.625s-1.079.304-1.625.5l3.594 3.594.969 1-1.219.625S23.351 25.428 19 25.846v3.156h-2v-3.031c-.335.011-.648.031-1 .031s-.666-.021-1-.031v3.031h-2v-3.156c-4.343-.417-6.781-1.594-6.781-1.594l-1.25-.625.969-1 3.594-3.594c-.546-.196-1.625-.5-1.625-.5l-1.25-.625 1-.969 4.406-4.406c-1.422-.322-2.438-.688-2.438-.688l-1.281-.625 1-.969 5.938-5.969zm0 2.844l-4 3.969c.593.199.714.356 2.188.5l1.813.188 1.813-.188c1.474-.144 1.594-.301 2.188-.5zm0 5l-1.188 1.156-4.594 4.594c.465.163.453.219 1.406.406l1.844.375-1.344 1.313-3.625 3.656c1.287.457 3.459 1.063 7.5 1.063 4.077 0 6.258-.607 7.531-1.063l-3.656-3.656-1.344-1.313 1.844-.375c.953-.188.941-.243 1.406-.406l-4.594-4.594z"}})])
          )
        }
      }
    